import CustomerBlacklistDetailPage from '@/redesign/domains/customerBlacklists/components/CustomerBlacklistDetail'

const CustomerBlacklistCreatePage = () => {
  return <CustomerBlacklistDetailPage />
}

export default CustomerBlacklistCreatePage
